import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - A Plus A Driving School</title>
        <meta name="description" content="Privacy Policy for A Plus A Driving School. Learn how we collect, use, and protect your personal information." />
      </Helmet>
      <div className="py-20 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-8">
            Privacy Policy
          </h1>
          <div className="text-sm text-secondary-text mb-8">
            Last updated: January 2026
          </div>
          <div className="prose prose-lg max-w-none space-y-6 text-secondary-text">
            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                1. Introduction
              </h2>
              <p>
                A Plus A Driving School (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                2. Information We Collect
              </h2>
              <p>We may collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Personal identification information (name, email address, phone number, date of birth)</li>
                <li>Payment information (processed securely through third-party payment processors)</li>
                <li>Driver&apos;s license or permit information</li>
                <li>Course enrollment and completion records</li>
                <li>Website usage data and analytics</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                3. How We Use Your Information
              </h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and manage our driving education services</li>
                <li>Process registrations and payments</li>
                <li>Communicate with you about your enrollment and courses</li>
                <li>Send important updates and notifications</li>
                <li>Improve our services and website</li>
                <li>Comply with legal obligations and DMV requirements</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                4. Information Sharing
              </h2>
              <p>
                We do not sell your personal information. We may share your information with:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Virginia DMV (as required by law for driver education programs)</li>
                <li>Payment processors (for secure payment processing)</li>
                <li>Service providers who assist in our operations</li>
                <li>Legal authorities when required by law</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                5. Data Security
              </h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                6. Your Rights
              </h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information (subject to legal requirements)</li>
                <li>Opt-out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                7. Contact Us
              </h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg mt-4">
                <p className="font-semibold">A Plus A Driving School</p>
                <p>10 Wellington Drive, Stafford, VA 22554</p>
                <p>Phone: <a href="tel:540-615-2418" className="text-primary hover:text-accent">540-615-2418</a></p>
                <p>Email: <a href="mailto:aplusavadrivingschool@gmail.com" className="text-primary hover:text-accent">aplusavadrivingschool@gmail.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

